export const Translations = {};

export const TestIds = {};

export const A11Y_DROPDOWN_CHEVRON_BUTTON_ARIA_LABEL_DEFAULT = 'More pages';
